import BigNumber from 'bignumber.js'
import { cva } from 'class-variance-authority'

import { formatHealthFactor } from '@/domain/common/format'
import { healthFactorToRiskLevel, riskLevelToTitle } from '@/domain/common/risk'
import { Typography } from '@/ui/atoms/typography/Typography'

export interface RiskIndicatorProps {
  healthFactor: BigNumber
}

const badgeVariants = cva('rounded-lg p-2.5 text-xs transition-colors duration-300', {
  variants: {
    variant: {
      liquidation: 'bg-red-400/10 text-red-400',
      risky: 'bg-red-400/10 text-red-400',
      moderate: 'bg-amber-400/10 text-amber-400',
      healthy: 'bg-teal-400/10 text-teal-400',
      'no debt': 'bg-teal-400/10 text-teal-400',
      unknown: '',
    },
  },
})

export function RiskIndicator({ healthFactor, ...props }: RiskIndicatorProps) {
  const riskLevel = healthFactorToRiskLevel(healthFactor)

  return (
    <div className="flex flex-col items-center gap-1" {...props}>
      <div
        className={badgeVariants({
          variant: riskLevel,
        })}
      >
        {riskLevelToTitle[riskLevel]}
      </div>
      <Typography variant="prompt">{formatHealthFactor(healthFactor)}</Typography>
    </div>
  )
}
